module.exports = __webpack_public_path__ + "img/6.80727513.webp";